export enum FinsteinHelperTypesEnum {
    COP_HELPER = 'COP_HELPER',
    PORTAL_HELPER = 'PORTAL_HELPER',
    GLOBAL_HELPER = 'GLOBAL_HELPER',
    BROKER_HELPER = 'BROKER_HELPER'
}